module.exports = __webpack_public_path__ + "img/workStatYnIcon.112c2bff.svg";